module.exports = __webpack_public_path__ + "static/media/heart-liked.9230f2ab.svg";